import { del, get, patch, post, put } from "./api_helper"

// branches
const getStaffList = craftsmanType =>
  get(`admin/assignment/staff/${craftsmanType}/list`)
const getRtwOrderList = params =>
  get(`admin/assignment/rtw-order/${params.weekId}/list`, params)
const getRtwOrderSizeList = weekId =>
  get(`admin/assignment/rtw-order/size/list`)
const getWeekList = () =>
  get(`admin/assignment/week/list?prevMonth=3&nextWeek=3`)
const getOrderList = params =>
  get(`admin/assignment/order/${params.weekId}/list`, params)
const putRtwOrder = params =>
  put(`admin/assignment/rtw-order/${params.id}`, params)
const putOrder = params => put(`admin/assignment/order/${params.id}`, params)
const deleteRtwOrder = params =>
  del(`admin/assignment/rtw-order/${params.id}`, params)
const deleteOrder = params => del(`admin/assignment/order/${params.id}`, params)
const patchData = params => patch(`admin/assignment/order/${params.id}`, params)
const getSingleOrder = (weekId, id) =>
  get(`admin/assignment/order/${weekId}/detail/${id}`)

const getSingleRTWOrder = (weekId, id) =>
  get(`admin/assignment/rtw-order/${weekId}/detail/${id}`)

const AssignmentAPI = {
  getStaffList,
  getRtwOrderList,
  getRtwOrderSizeList,
  getWeekList,
  getOrderList,
  putRtwOrder,
  putOrder,
  deleteRtwOrder,
  deleteOrder,
  patchData,
  getSingleOrder,
  getSingleRTWOrder,
}

export default AssignmentAPI
